import { render, staticRenderFns } from "./UpdateUsers.vue?vue&type=template&id=bf80ea8a&scoped=true&"
import script from "./UpdateUsers.vue?vue&type=script&lang=js&"
export * from "./UpdateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf80ea8a",
  null
  
)

export default component.exports